/**
 * CostePanel — GEN-MO-016: coste en euros por mes, modelo y paso. Solo admin: el ítem
 * `coste` lo proyecta el kernel y la puerta real es GET /v1/admin/coste (403 al resto).
 * El kernel decide qué es «estimado» y «sin desglose por paso»; aquí solo se pintan.
 * Los euros son los de la tarifa y el tipo de cambio de hoy, no los de entonces.
 */

import { useEffect, useState } from 'react'
import { getCoste } from '../api/client.js'

const NOTA = 'Si no coincide con la factura del proveedor, manda la del proveedor.'

const eur = v => `${Number(v).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} €`

function Mes({ m }) {
  return (
    <section className="coste-mes">
      <div className="coste-mes__cab">
        <h3>{m.mes}</h3>
        {m.sin_desglose_paso && <span className="coste-marca">sin desglose por paso</span>}
      </div>
      <table className="mec-tabla">
        <thead>
          <tr><th>Modelo</th><th>Paso</th><th className="coste-eur">Coste</th></tr>
        </thead>
        <tbody>
          {m.filas.map((f, i) => (
            <tr key={`${f.modelo}|${f.paso}|${i}`}>
              <td>{f.modelo || '—'}</td>
              <td>{f.paso || 'sin desglose'}</td>
              <td className="coste-eur">
                {eur(f.eur)} {f.estimado && <span className="coste-marca">estimado</span>}
              </td>
            </tr>
          ))}
          <tr className="coste-total">
            <td colSpan={2}>Total del mes</td>
            <td className="coste-eur">{eur(m.total_eur)}</td>
          </tr>
        </tbody>
      </table>
    </section>
  )
}

export default function CostePanel() {
  const [datos, setDatos] = useState(null)

  useEffect(() => {
    let vivo = true
    getCoste()
      .then(d => vivo && setDatos(d))
      .catch(() => vivo && setDatos({ error: 'No se ha podido cargar el coste.' }))
    return () => { vivo = false }
  }, [])

  return (
    <section className="mec-visor">
      <h2>Coste</h2>
      <p className="coste-nota">{NOTA}</p>
      {!datos && <p>Cargando…</p>}
      {datos?.error && <div className="mec-error" role="alert">{datos.error}</div>}
      {datos?.meses && (
        <>
          <p className="coste-nota">
            Tipo de cambio: 1 USD = {datos.eur_por_usd} EUR (el de hoy). Corte de mes en {datos.zona}.
          </p>
          {datos.meses.map(m => <Mes key={m.mes} m={m} />)}
        </>
      )}
    </section>
  )
}
